export const QBANK_DASHBOARD = {
  VIEW: 'qbank.dashboard-view',
};

export const QUESTION = {
  VIEW: 'qbank.question-view',
  CREATE: 'qbank.question-create',
  UPDATE: 'qbank.question-update',
  STATUS: 'qbank.question-status',
};

export const STRUCTURE = {
  VIEW: 'qbank.structure-view',
  CREATE: 'qbank.structure-create',
  UPDATE: 'qbank.structure-update',
  STATUS: 'qbank.structure-status',
};

export const LOS = {
  VIEW: 'qbank.los-view',
  CREATE: 'qbank.los-create',
  UPDATE: 'qbank.los-update',
  DELETE: 'qbank.los-delete',
};

export const QBANK_SETTINGS = {
  VIEW: 'qbank.setting-view',
  UPDATE: 'qbank.setting-update',
};

export const QBANK_AUDIT_LOG = {
  VIEW: 'qbank.auditLog-view',
};

export const ROLE = {
  VIEW: 'setting.role-view',
  CREATE: 'setting.role-create',
  UPDATE: 'setting.role-update',
  DELETE: 'setting.role-delete',
};

export const USER = {
  VIEW: 'setting.user-view',
  CREATE: 'setting.user-create',
  UPDATE: 'setting.user-update',
  STATUS: 'setting.user-status',
  DELETE: 'setting.user-delete',
};

export const USER_MANAGEMENT_AUDIT_LOG = {
  VIEW: 'setting.auditLog-view',
};

export const EXAMINATION_COURSE = {
  VIEW: 'exam.examinationCourse-view',
  CREATE: 'exam.examinationCourse-create',
};

export const QCONFIG = {
  VIEW: 'exam.qconfig-view',
  UPDATE: 'exam.qconfig-update',
  CREATE: 'exam.qconfig-create',
  STATUS: 'exam.qconfig-status',
  DELETE: 'exam.qconfig-delete',
};

export const QSET = {
  VIEW: 'exam.qset-view',
  CREATE: 'exam.qset-create',
  UPDATE: 'exam.qset-update',
  STATUS: 'exam.qset-status',
  DELETE: 'exam.qset-delete',
};

export const EXAM_COURSE_AUDIT_LOG = {
  VIEW: 'exam.auditLog-view',
};

export const QUESTION_CREATION_TASK = {
  VIEW: 'task.questionCreation-view',
  CREATE: 'task.questionCreation-create',
};

export const QUESTION_REVIEW_TASK = {
  VIEW: 'task.questionReview-view',
  CREATE: 'task.questionReview-create',
};

export const QSET_REVIEW_TASK = {
  VIEW: 'task.qsetReview-view',
  CREATE: 'task.qsetReview-create',
};

export const ADMIN_EXAM_CENTER = {
  VIEW: 'ecAdmin-examCenter.examCenter-view',
  UPDATE: 'ecAdmin-examCenter.examCenter-update',
  CREATE: 'ecAdmin-examCenter.examCenter-create',
};

export const ADMIN_EXAM_CENTER_MEMBER = {
  VIEW: 'ecAdmin-examCenter.member-view',
  CREATE: 'ecAdmin-examCenter.member-create',
  DELETE: 'ecAdmin-examCenter.member-delete',
};

export const ADMIN_EXAM_CENTER_EXAM_COURSE = {
  VIEW: 'ecAdmin-examCenter.examCourse-view',
  CREATE: 'ecAdmin-examCenter.examCourse-create',
};

export const ADMIN_EXAM_COURSE_SETTINGS = {
  VIEW: 'ecAdmin-examCourse.settings-view',
  UPDATE: 'ecAdmin-examCourse.settings-update',
  CREATE: 'ecAdmin-examCourse.settings-create',
};

export const ADMIN_EXAM_ASSIGNING = {
  VIEW: 'ecAdmin-examDistribution.examAssigning-view',
  UPDATE: 'ecAdmin-examDistribution.examAssigning-update',
};

export const ADMIN_AVAILABLE_QSETS = {
  VIEW: 'ecAdmin-examDistribution.availableQSets-view',
};

export const ADMIN_PROCTOR = {
  VIEW: 'ecAdmin-proctor.proctor-view',
  UPDATE: 'ecAdmin-proctor.proctor-update',
};

export const ADMIN_PROCTOR_REQUEST = {
  VIEW: 'ecAdmin-proctor.proctorRequest-view',
  UPDATE: 'ecAdmin-proctor.proctorRequest-update',
};

export const ADMIN_PROCTOR_REQUEST_FIRST_TIER_REVIEW = {
  VIEW: 'ecAdmin-proctor.proctorFirstTierReviewer-view',
  UPDATE: 'ecAdmin-proctor.proctorFirstTierReviewer-update',
};

export const ADMIN_PROCTOR_REQUEST_SECOND_TIER_REVIEW = {
  VIEW: 'ecAdmin-proctor.proctorSecondTierReviewer-view',
  UPDATE: 'ecAdmin-proctor.proctorSecondTierReviewer-update',
};

export const ADMIN_PROCTOR_EXPIRATION = {
  VIEW: 'ecAdmin-proctor.proctorExpiration-view',
};

export const ADMIN_PROCTOR_AUDIT_LOG = {
  VIEW: 'ecAdmin-proctor.auditLog-view',
};

export const ADMIN_EXAM_LOCATION = {
  VIEW: 'ecAdmin-location.location-view',
  UPDATE: 'ecAdmin-location.location-update',
};

export const ADMIN_EXAM_LOCATION_USAGE = {
  VIEW: 'ecAdmin-location.locationUsage-view',
  UPDATE: 'ecAdmin-location.locationUsage-update',
};

export const ADMIN_WEB_REGISTER_ANNOUNCEMENT = {
  VIEW: 'ecAdmin-announcement.announcement-view',
  CREATE: 'ecAdmin-announcement.announcement-create',
};

export const ADMIN_EXAM_LOCATION_REQUEST = {
  VIEW: 'ecAdmin-location.locationRequest-view',
  UPDATE: 'ecAdmin-location.locationRequest-update',
};

export const ADMIN_EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW = {
  VIEW: 'ecAdmin-location.locationFirstTierReviewer-view',
  UPDATE: 'ecAdmin-location.locationFirstTierReviewer-update',
};

export const ADMIN_EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW = {
  VIEW: 'ecAdmin-location.locationSecondTierReviewer-view',
  UPDATE: 'ecAdmin-location.locationSecondTierReviewer-update',
};

export const ADMIN_EXAM_LOCATION_AUDIT_LOG = {
  VIEW: 'ecAdmin-location.auditLog-view',
};

export const ADMIN_BLOCKED_USER = {
  VIEW: 'ecAdmin-blocklist.blockedUser-view',
  UPDATE: 'ecAdmin-blocklist.blockedUser-update',
  CREATE: 'ecAdmin-blocklist.blockedUser-create',
};

export const ADMIN_EXAM_LOCATION_CANCELATION = {
  VIEW: 'ecAdmin-location.locationCancelation-view',
};

export const ADMIN_QUESTIONNAIRE_REPORT = {
  VIEW: 'ecAdmin-questionnaire.report-view',
};

export const EXAM_CENTER = {
  VIEW: 'ec-examCenter.examCenter-view',
  UPDATE: 'ec-examCenter.examCenter-update',
};

export const EXAM_CENTER_MEMBER = {
  VIEW: 'ec-examCenter.member-view',
};

export const EXAM_CENTER_EXAM_COURSE = {
  VIEW: 'ec-examCenter.examCourse-view',
};

export const EXAM_EVENT = {
  VIEW: 'ec-examEvent.examEvent-view',
  UPDATE: 'ec-examEvent.examEvent-update',
  CREATE: 'ec-examEvent.examEvent-create',
};

export const EXAM_EVENT_AUDIT_LOG = {
  VIEW: 'ec-examEvent.auditLog-view',
};

export const EXAM_EVENT_EXAMINEES = {
  VIEW: 'ec-examEvent.examinees-view',
  UPDATE: 'ec-examEvent.examinees-update',
};

export const EXAM_EVENT_RESULTS = {
  VIEW: 'ec-examEvent.results-view',
  UPDATE: 'ec-examEvent.results-update',
};

export const PROCTORING = {
  VIEW: 'ec-proctoring.details-view',
  UPDATE: 'ec-proctoring.details-update',
};

export const PROCTORING_REGISTRATION = {
  VIEW: 'ec-proctoring.registration-view',
  UPDATE: 'ec-proctoring.registration-update',
};

export const PROCTORING_EKYC = {
  VIEW: 'ec-proctoring.eKyc-view',
  UPDATE: 'ec-proctoring.eKyc-update',
};

export const PROCTOR = {
  VIEW: 'ec-proctor.proctor-view',
  UPDATE: 'ec-proctor.proctor-update',
};

export const PROCTOR_REQUEST = {
  VIEW: 'ec-proctor.proctorRequest-view',
  CREATE: 'ec-proctor.proctorRequest-create',
  UPDATE: 'ec-proctor.proctorRequest-update',
  DELETE: 'ec-proctor.proctorRequest-delete',
};

export const PROCTOR_EXPIRATION = {
  VIEW: 'ec-proctor.proctorExpiration-view',
};

export const EXAM_LOCATION = {
  VIEW: 'ec-location.location-view',
  UPDATE: 'ec-location.location-update',
};

export const EXAM_LOCATION_REQUEST = {
  VIEW: 'ec-location.locationRequest-view',
  CREATE: 'ec-location.locationRequest-create',
  UPDATE: 'ec-location.locationRequest-update',
  DELETE: 'ec-location.locationRequest-delete',
};

export const EXAM_LOCATION_CANCELATION = {
  VIEW: 'ec-location.locationCancelation-view',
};

export const EXAM_EVENT_OVERVIEW_REPORT = {
  VIEW: 'report.examEventOverviewReport-view',
};

export const EXAM_COURSE_ANALYSIS_REPORT = {
  VIEW: 'report.examCourseAnalysisReport-view',
};

export const QBANK_ITEMS_ANALYSIS_REPORT = {
  VIEW: 'report.qbankItemsAnalysisReport-view',
  UPDATE: 'report.qbankItemsAnalysisReport-update',
};

export const QBANK_ITEMS_ANALYSIS_YEARLY_REPORT = {
  VIEW: 'report.qbankItemsAnalysisYearlyReport-view',
};

export const QSET_USAGE_STATUS_REPORT = {
  VIEW: 'report.qsetUsageStatusReport-view',
};

export const QUESTION_USAGE_BY_QSET_REPORT = {
  VIEW: 'report.questionUsageByQsetReport-view',
};

export const QUESTIONNAIRE_REPORT = {
  VIEW: 'report.questionnaireReport-view',
};

export const ADMIN_SET_PORTAL_EXAM_RESULT_FILE = {
  VIEW: 'ecAdmin-setPortal.examResultFile-view',
};
